import React from 'react';
import { TextField } from '@material-ui/core';

export default function TextArea(props) {
  const { name, label, value, error = null, onChange, rows = 4 } = props;

  return (
    <TextField
      variant="outlined"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      multiline
      rows={rows}
      style={{
        borderBlockColor: 'white',
        width: '100%',
      }}
      {...(error && { error: true, helperText: error })}
    />
  );
}
